import axios from 'axios'
import {getENV} from './utils'

const Axios = axios.create({
  baseURL: '//' + getENV().tjyy,
  timeout: 10000,
  responseType: 'json'
})

// POST传参序列化(添加请求拦截器)
Axios.interceptors.request.use(
  config => {
    // 若是有做鉴权token , 就给头部带上token
    // 若是需要跨站点,存放到 cookie 会好一点,限制也没那么多,有些浏览环境限制了 localstorage 的使用
    // 这里localStorage一般是请求成功后我们自行写入到本地的,因为你放在vuex刷新就没了
    // 一些必要的数据写入本地,优先从本地读取
    let isOpen = true
    Log('请求' + config.url, config.data)
    if (config.data && config.data.loading === false) {
      isOpen = false
    }
    isOpen && bus.$emit('loading', '加载中...')
    return config
  },
  error => {
    // error 的回调信息,看贵公司的定义
    let {data} = error
    return Promise.reject(data.errMsg)
  }
)

// 返回状态判断(添加响应拦截器)
Axios.interceptors.response.use(
  res => {
    let {data, config} = res
    Log('响应内容', data)
    // 对响应数据做些事
    if (data.code !== 0) {
      bus.$emit('msg', data.errMsg)
      bus.$emit('loading', false)
      return Promise.reject(data.errMsg)
    }
    let isOpen = true
    if (config.data && config.data.loading === false) {
      isOpen = false
    }
    isOpen && bus.$emit('loading', false)
    return data
  },
  error => {
    bus.$emit('loading', false)
    console.error('error', error)
    console.log('response', error.response)
    if (error.response) {
      bus.$emit('msg', error.response.data.exception || error.message)
    } else {
      bus.$emit('msg', error.message)
    }
  }
)

export default Axios



// WEBPACK FOOTER //
// ./src/lib/http2.js